<template lang="html">

    <section class="contenedor-noticias">
        <h2 class="lined">Últimas entradas</h2>
        <div class="contenedor-noticias container row-start ais">
            <template v-if="!!noticias">
            <!-- <slick ref="slick" :options="slickOptions"> -->
                <!-- <article class="slide" v-for="(noticia,key) in noticias"> -->
                <noticia-el :key="key" v-for="(noticia,key) in noticias" :data="noticia"></noticia-el>
                <!-- </article> -->
            <!-- </slick> -->
        </template>
        </div>

        <router-link class="show-more" :to="$t('enlaces.noticias')">Ver más</router-link>

    </section>

</template>

<script lang="js">

    import { mapGetters } from 'vuex'

    import noticia from '@/components/parts/noticia-el'


    import Slick from 'vue-slick';

    export default {
        name: 'noticias-home',
        data() {
            return {
                slickOptions: {
                    slidesToShow: 3,
                    responsive: [
    {
      breakpoint: 1100,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
      }
    },
    {
      breakpoint: 650,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
  ]
                },
                min : false
            };
        },
        computed: {
            ...mapGetters({
                noticias: 'getNoticiasHome'
            })
        },
        components: {
            'noticia-el': noticia,
            Slick
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/parts/noticias-home.vue